import { useToken } from "@dexteel/mesf-core";
import { Button, Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";
import { useState } from "react";
import { PreviewerAttachment } from "../previewer-attachment";

type Props = EditableCallbackParams;

export const AttachmentsDownloadButtons = ({ data }: Props) => {
	const [displayViewerAttachment, setDisplayViewerAttachment] =
		useState<boolean>(false);
	const { token: bearerToken } = useToken();

	const openAttachmentViewer = () => {
		setDisplayViewerAttachment(true);
	};

	if (data?.id !== -1) {
		return (
			<Grid
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				{data?.Path && (
					<>
						<Grid item md={6} xs={12}>
							<Button
								onClick={() => openAttachmentViewer()}
								fullWidth
								variant="outlined"
								style={{
									backgroundColor: "#FFF",
									textDecoration: "none !important",
									fontWeight: 500,
									fontSize: "10px",
									borderRadius: "3px",
									border: "1px solid #3F51B5",
									color: "#3F51B5",
								}}
							>
								VIEW
							</Button>
						</Grid>
						<Grid item md={6} xs={12}>
							<Button
								href={`/backend/files/${data?.UploadFileId}/download?Authorization=${bearerToken}`}
								target="_blank"
								rel="noopener noreferrer"
								fullWidth
								variant="contained"
								color="primary"
								style={{
									color: "#FFFF",
									textDecoration: "none !important",
									fontWeight: 500,
									fontSize: "10px",
									borderRadius: "3px",
									border: "1px solid #3F51B5",
								}}
								download={`${data?.FileName} `}
							>
								DOWNLOAD
							</Button>
						</Grid>
					</>
				)}
				{displayViewerAttachment && (
					<PreviewerAttachment
						attachmentSelected={data}
						displayViewerAttachment={displayViewerAttachment}
						setDisplayViewerAttachment={setDisplayViewerAttachment}
					/>
				)}
			</Grid>
		);
	} else return <></>;
};
